import React from "react";

export default function PricingHeader() {
  return (
    <div
      className="w-full pb-16 pt-14 px-2"
      style={{
        background: "linear-gradient(115deg, #EACAFF 0%, #BFC2FF 62%, #F0F5FF 100%)"
      }}
    >
      <div className="mb-12 flex flex-col items-center">
        <h1 className="text-[2.1rem] md:text-4xl font-bold text-gray-900 mb-4 mt-4 text-center leading-snug drop-shadow-sm">
          Choose the plan that's right for you
        </h1>
        <div className="text-lg text-gray-700 text-center max-w-2xl">
          Upgrade to unlock premium features and AI tools for seamless video editing.
        </div>
      </div>
    </div>
  );
}
